angular
    .module('empower.modules', [
        "empower.index",
        'empower.home',
        'empower.userProfile',
        'empower.faqs',
        'empower.policy',
        'empower.claim',   
        'empower.claimPerformanceReport',
        'empower.termCondition',
        'empower.contactUs',
        'empower.uploadDocument',
        'empower.lodgeClaim',
        'empower.lodgeClaimACTG',
        'empower.memberBenefit', 
        'empower.inbox',       
        'vic.claim'
    ]);
